__turbopack_context__.v({
  "assetGrid": "created-assets-module__qEqjlG__assetGrid",
  "card": "created-assets-module__qEqjlG__card",
  "ecmrce": "created-assets-module__qEqjlG__ecmrce",
  "link": "created-assets-module__qEqjlG__link",
  "name": "created-assets-module__qEqjlG__name",
});
